import React from 'react';
import { CalendarDaysIcon, CheckIcon, ClipboardListIcon, ShieldIcon, UsersIcon } from 'lucide-react';
const stats = [[CalendarDaysIcon, '300+', 'Pages'], [ClipboardListIcon, '200+', 'Sessions'], [UsersIcon, '120+', 'Drills & Games'], [ShieldIcon, 'All', 'Age Groups']];
const tags = ['Beginner (9th Category)', 'Elementary (7th–8th)', 'Intermediate (5th–6th)', 'Advanced (3rd–4th)', 'High Performance (1st–2nd)', 'All Sports & Units'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#10372a] px-5 py-20" data-id="element-211" data-mp="2wsxsla0j2l0x">
      <div className="mx-auto max-w-6xl text-center" data-id="element-212" data-mp="2srvskqyse4xw">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-213" data-mp="2sqaxn08k8jzi">
          The most complete system for PE teachers worldwide
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-214" data-mp="2itg30sfer3qi">
          P.E. <span className="text-emerald-300" data-id="element-215" data-mp="2dxh5ofc3qbdy">Ready 360</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-slate-300" data-id="element-216" data-mp="13xn6httd9lwt">
          Over 300 pages of lesson plans, professional skill drills, games,
          technique guides, physical conditioning and class-management tools —{' '}
          <strong className="text-white" data-id="element-217" data-mp="yzlhytd68udy">all done for you.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-218" data-mp="1mppll0qd0u4y">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-emerald-300/25 bg-[#09281d] p-6" data-id="element-219" data-mp="1rp2ars4pedap">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-220" data-mp="1cr04392dlbp8" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-221" data-mp="1hptjx854xesk">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-222" data-mp="1bl8o9pterw8">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-emerald-300/25 bg-[#09281d] p-7" data-id="element-223" data-mp="28ymm52dc2b40">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-224" data-mp="23z1n6ry5y2ra">
            Full coverage, every category
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-225" data-mp="1z79wmhf0bx15">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-emerald-300/25 bg-[#10372a] px-3 py-2 text-xs font-bold text-white" data-id="element-226" data-mp="1u86ylgxg2r2o">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-227" data-mp="1l7h72pf7vmur" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}